import { useEffect, useContext } from "react"
import { useParams } from 'react-router-dom'
import { UserContext } from "../../../context/userContext"
import { useFormikContext } from "formik"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function Owner({ field, block, index }) {
  const { type } = useParams()
  const isEnterprise = type === 'enterprise'
  const userCtx = useContext(UserContext)

  const formik = useFormikContext()
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    if (isEnterprise) {
      formik.setFieldValue(field.field_name, userCtx.session.user.enterprise_id)
    } else {
      formik.setFieldValue(field.field_name, userCtx.session.user.organization_id)
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}